<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PrintOptions from "@/components/modals/print-options.vue";
import VerificationCode from "@/components/modals/verification-code.vue";
import ActualCash from "@/components/widgets/actual-cash.vue";
import Disbursement from "@/components/widgets/disbursement-widget.vue";
import ForRelease from "@/components/widgets/for-release-widget.vue";
import ACTransModal from "@/components/modals/actual-cash-transactions.vue";
import DisbursementTrans from "@/components/modals/disbursement-data-modal.vue";
import ObligationTrans from "@/components/modals/obligation-modal.vue";
export default {
    page: {
        title: "Cashier Fund Source",
    },
    components: {
        Layout,
        PageHeader,
        VerificationCode,
        ActualCash,
        PrintOptions,
        Disbursement,
        ForRelease,
        ACTransModal,
        DisbursementTrans,
        ObligationTrans
    },
    data() {
        return {
            title: "Cashier",
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Cashier",
                    active: true,
                },
            ],
            selectedMenu: "actual cash",
            fundClusters: [],
            favorites: [],
            loadFavorites: false,
            fcStatus: "active",
            selectedFundSource: null,
            modalTitle: ''
        }
    },
    async created(){
        this.loadFavorites = true;
        await this.getFundClusters();
        await this.getFavorites(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.loadFavorites = false;
    },
    methods: {
        async changeCycle(cycle) {
            this.loadFavorites = true;
            await this.getFavorites(cycle, this.$store.state.data.selectedCampus.id);
            this.$refs.actualCash.getFCStatus(this.fcStatus);
            this.loadFavorites = false;
        },
        async changeCampus(campus) {
            this.loadFavorites = true;
            await this.getFavorites(this.$store.state.data.cycle, campus.id);
            this.$refs.actualCash.getFCStatus(this.fcStatus);
            this.loadFavorites = false;
        },
        async getFundClusters(){
            this.fundClusters = [];
            try{
                const { data: response } = await this.$store.dispatch("fundcluster/GetFundCluster");
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }
                const isAdmin = this.$store.state.decrypt.isAdmin();
                if (isAdmin) {
                   return this.fundClusters = response;
                }
                const fcAccess = this.$store.state.decrypt.userAccessList().find((item) =>  item.Type.toLowerCase() === "finance" && item.Access.toLowerCase().includes("fund cluster"));
                if(fcAccess){
                    const filterAccess = this.$store.state.decrypt.userAccessList().filter((item) => item.Type.toLowerCase() === "finance" && item.ParentId == fcAccess.Id);
                    let fcAccList = [];
                    filterAccess.forEach((item) => {
                        fcAccList.push(Number(item.Access.split("-")[0]));
                    });
                    this.fundClusters = response.filter((item) => fcAccList.includes(item.id));
                }
            }catch(err){
                this.showToast("An error occurred while fetching fund clusters.", "error");
            }
        },
        async getFavorites(cycle, campusId){
            this.favorites = [];
            try{
                const { data: response } = this.$store.dispatch("userfundsourcefavorite/getMyFavoriteFundSource", {cycle, campusId});
                if(!response) return;
                if(response.error){
                    return this.showToast(response.errorMessage, "error");
                }   
                this.favorites = response;
            }catch(err){
                this.showToast("An error occurred while fetching favorite fund sources.", "error");
            }
        },
        async verifyNow(code) {
            const record = await this.$store
                .dispatch("verification/verifyCode", { code: code, type: this.verificationType})
                .then((res) => {
                if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                }
                return this.$store.state.disbursement.tempDisbursement;
            });
            if (!record) return;
            this.$bvModal.hide("verify-modal");
        },
        getFCStatus(status){
            this.fcStatus = status;
            this.$refs.actualCash.getFCStatus(status);
        },
        viewTransactions(fundSource){
            this.selectedFundSource = fundSource;
            this.modalTitle = `${fundSource.sourceName} Transactions`;
            this.$bvModal.show("actual-cash-transactions-modal");
            this.$refs.acTransactions.fetchTransactions(fundSource);
        },
        updateFSBalance(newBalance){
            if(this.selectedFundSource){
                this.selectedFundSource.actualCashBalance = newBalance;
            }
        },
        viewObligations(fundSource){
            this.$refs.obligationTrans.getData(fundSource);
            this.$bvModal.show("fs-obligation-modal");
        },
        viewDisbursement(fundSource){
            this.$refs.disbursementTrans.getData(fundSource);
            this.$bvModal.show("fs-disbursement-modal");
        },
        generateACReport({ type, fundSource }){
            if(!fundSource) return;
            let apiUrl = "";
            let routeVariables = [fundSource.id, this.$store.state.data.cycle];
            if(type === 'expenditure'){
                apiUrl = "/api/Report/Finance/ObjectOfExpenditure/Allotment/FundSource";
            }else if(type === 'utilization'){
                apiUrl = "/api/Report/Finance/Utilization";
                routeVariables = [fundSource.id];
            }else if(type === 'obligation'){
                apiUrl = "/api/Report/Finance/Obligations";
                routeVariables = [this.$store.state.data.cycle, fundSource.id];
            }else if(type === 'disbursement'){
                apiUrl = "/api/Report/Finance/Disbursement";
                routeVariables = [this.$store.state.data.cycle, fundSource.id];
            }
            this.$refs.printOpt.putOptions({
                apiUrl: apiUrl,
                routeVariables: routeVariables,
            });
            this.$bvModal.show("print-options-modal");
        }
    }
}
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus">
        <PageHeader :title="title" :items="items" />
        <div class="position-relative">
            <div class="d-flex gap-2 border-bottom pb-3">
                <div 
                    class="border rounded py-2 d-flex align-items-center justify-content-center w-250px cursor-pointer"
                    :class="{'bg-purple text-white': selectedMenu === 'actual cash' }"
                    @click="selectedMenu = 'actual cash'"
                >
                    <p class="mb-0 font-size-18 d-flex align-items-center gap-1"><i class="bx bx-money"></i> Actual Cash</p>
                </div>
                <div 
                    class="border rounded py-2 d-flex align-items-center justify-content-center w-250px cursor-pointer"
                    :class="{'bg-purple text-white': selectedMenu === 'disbursement' }"
                    @click="selectedMenu = 'disbursement'"
                >
                    <p class="mb-0 font-size-18 d-flex align-items-center gap-1"><i class="bx bx-file"></i> Disbursements</p>
                </div>
                <div 
                    class="border rounded py-2 d-flex align-items-center justify-content-center w-250px cursor-pointer"
                    :class="{'bg-purple text-white': selectedMenu === 'for release' }"
                    @click="selectedMenu = 'for release'"
                >
                    <p class="mb-0 font-size-18 d-flex align-items-center gap-1"><i class="bx bx-paper-plane"></i> For Release</p>
                </div>
            </div>
            <template v-if="selectedMenu === 'actual cash'">
                <div class="position-absolute d-flex gap-2" style="top: 10px; right: 0;">
                    <div class="border rounded py-2 px-5 d-flex align-items-center justify-content-center cursor-pointer"
                        :class="{'bg-green text-white': fcStatus === 'active' }"
                        @click="getFCStatus('active')"
                    >
                        <p class="mb-0 font-size-14">Active</p>
                    </div>
                    <div class="border rounded py-2 px-5 d-flex align-items-center justify-content-center cursor-pointer"
                        :class="{'bg-danger text-white': fcStatus === 'expired' }"
                        @click="getFCStatus('expired')"
                    >
                        <p class="mb-0 font-size-14">Expired</p>
                    </div>
                </div>
                <ActualCash 
                    :fundClusters="fundClusters"
                    :favorites="favorites"
                    :loadFC="loadFavorites"
                    @view-transactions="viewTransactions"
                    @view-obligations="viewObligations"
                    @view-disbursement="viewDisbursement"
                    @generate-report="generateACReport"
                    ref="actualCash"
                />
            </template>
            <Disbursement 
                v-if="selectedMenu === 'disbursement'"
                ref="disbursement"
            />
            <ForRelease 
                v-if="selectedMenu === 'for release'"
                ref="forRelease"
            />
            <VerificationCode
                @dropCode="verifyNow"
                ref="verification"
            />
            <ACTransModal
                ref="acTransactions"
                :modalTitle="modalTitle"
                @update-balance="updateFSBalance"
            />
            <DisbursementTrans ref="disbursementTrans" />
            <ObligationTrans ref="obligationTrans" />
            <PrintOptions ref="printOpt" />
        </div>
    </Layout>
</template>